<template>
  <div ref="viewPage" class="grid pb-0 bg-white" style="height: calc(100vh - 90px)">
    <div ref="listOption" class="grid-title">
      <h4 class="mr-auto">{{ $t("LIST_FORMULAR") }}</h4>
      <div>
        <div class="text-right">
          <v-btn
            depressed
            color="primary"
            class="mr-2"
            small
            @click="openPopupSetup"
          >
            <i class="icon-settings mr-1"></i>
            {{ $t("SET_UP_FORMULAR") }}
          </v-btn>
          <v-btn
            depressed
            color="primary"
            class="mr-2"
            small
            outlined
            @click="calculateFormulaByDate('')"
          >
            <i class="icon-calendar_month mr-1"></i>
            {{ $t("SET_UP_FORMULAR_BY_DATE_RANGE") }}
          </v-btn>
          <v-btn
            depressed
            color="primary"
            small
            outlined
            @click="$router.push({ name: 'master-rate-overview' })"
          >
            <v-icon light size="16px" left>arrow_back</v-icon>
            {{ $t("DERIVED") }}
          </v-btn>
        </div>
      </div>
    </div>
    <div class="grid-body border-top-unset">
      <div class="body-room-sale">
        <div class="grid pb-0">
          <div class="grid-body">
            <v-progress-linear
              color="secondary"
              indeterminate
              rounded
              height="3"
              v-if="isLoading"
            ></v-progress-linear>
            <div ref="options" class="p-3">
              <div class="d-flex align-items-end flex-wrap">
                <div class="w-20 pr-2 mb-3">
                  <label>
                    {{ $t("ROOM_TYPE_BASE") }}
                  </label>
                  <v-autocomplete
                    item-text="text"
                    item-value="value"
                    :items="roomTypes"
                    v-model="filters.master.roomTypeId"
                    class="w-100"
                    outlined
                    dense
                    :multiple="true"
                    chips
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1">
                        <a
                          class="text-primary"
                          @click="
                            filters.master.roomTypeId = roomTypes.map(
                              (e) => e.value
                            )
                          "
                          >{{ $t("SELECT_ALL") }}</a
                        >
                        |
                        <a
                          class="text-primary"
                          @click="filters.master.roomTypeId = []"
                          >{{ $t("UN_SELECT_ALL") }}</a
                        >
                      </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="
                          removeChips(index, filters.master.roomTypeId)
                        "
                      >
                        <span class="text-truncate-min text-truncate">{{
                          item.text
                        }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filters.master.roomTypeId.length - 1 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="w-20 pr-2 mb-3">
                  <label>
                    {{ $t("SALE_PACKAGE_BASE") }}
                  </label>
                  <v-autocomplete
                    item-text="text"
                    item-value="value"
                    :items="ratePlans"
                    v-model="filters.master.ratePlanId"
                    class="w-100"
                    outlined
                    dense
                    :multiple="true"
                    chips
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1">
                        <a
                          class="text-primary"
                          @click="
                            filters.master.ratePlanId = ratePlans.map(
                              (e) => e.value
                            )
                          "
                          >{{ $t("SELECT_ALL") }}</a
                        >
                        |
                        <a
                          class="text-primary"
                          @click="filters.master.ratePlanId = []"
                          >{{ $t("UN_SELECT_ALL") }}</a
                        >
                      </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="
                          removeChips(index, filters.master.ratePlanId)
                        "
                      >
                        <span class="text-truncate-min text-truncate">{{
                          item.text
                        }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filters.master.ratePlanId.length - 1 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="w-20 pr-2 mb-3">
                  <label>
                    {{ $t("SALE_CHANNEL_BASE") }}
                  </label>
                  <v-autocomplete
                    item-text="text"
                    item-value="value"
                    :items="otas"
                    v-model="filters.master.otaId"
                    class="w-100"
                    outlined
                    dense
                    :multiple="true"
                    chips
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1">
                        <a
                          class="text-primary"
                          @click="
                            filters.master.otaId = otas.map((e) => e.value)
                          "
                          >{{ $t("SELECT_ALL") }}</a
                        >
                        |
                        <a
                          class="text-primary"
                          @click="filters.master.otaId = []"
                          >{{ $t("UN_SELECT_ALL") }}</a
                        >
                      </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="removeChips(index, filters.master.otaId)"
                      >
                        <span class="text-truncate-min text-truncate">{{
                          item.text
                        }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filters.master.otaId.length - 1 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="w-20 pr-2 mb-3">
                  <label>
                    {{ $t("RESTRICTION") }}
                  </label>
                  <v-autocomplete
                    item-text="text"
                    item-value="value"
                    :items="restrictions"
                    v-model="filters.master.restrictionId"
                    class="w-100"
                    outlined
                    dense
                    multiple
                    chips
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1">
                        <a
                          class="text-primary"
                          @click="
                            filters.master.restrictionId = restrictions.map(
                              (e) => e.value
                            )
                          "
                          >{{ $t("SELECT_ALL") }}</a
                        >
                        |
                        <a
                          class="text-primary"
                          @click="filters.master.restrictionId = []"
                          >{{ $t("UN_SELECT_ALL") }}</a
                        >
                      </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="
                          removeChips(index, filters.master.restrictionId)
                        "
                      >
                        <span class="text-truncate-min text-truncate">{{
                          item.text
                        }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption"
                        >(+{{ filters.master.restrictionId.length - 1 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="w-20 mb-3 d-flex justify-content-between">
                  <v-badge :content="numberSearch" :value="numberSearch" color="green" overlap right class="badge-advance caculate">
                    <v-btn class="p-0" color="primary" depressed plain v-b-toggle.collapse-1 :title="$t('ADVANCE_SEARCH')" @click="showMore()"> 
                      <i class="icon-search fs-18 font-weight-bold"></i>
                      <i class="icon-plus fs-16" style="position: relative; left: -10px; top: -2px"></i>
                    </v-btn>
                  </v-badge>
                  <v-btn depressed color="primary" @click="search()">
                    <i class="icon-search mr-1"></i>
                    {{ $t("_BOOKING.SEARCH") }}
                  </v-btn>
                </div>
              </div>
              <b-collapse id="collapse-1">
                <div class="d-flex align-items-end flex-wrap">
                  <div class="w-20 pr-2 mb-3">
                    <label>
                      {{ $t("ROOM_TYPE_DERIVED") }}
                    </label>
                    <v-autocomplete
                      item-text="text"
                      item-value="value"
                      :items="roomTypes"
                      v-model="filters.children.roomTypeId"
                      class="w-100"
                      outlined
                      dense
                      :multiple="true"
                      chips
                    >
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1">
                          <a
                            class="text-primary"
                            @click="
                              filters.children.roomTypeId = roomTypes.map(
                                (e) => e.value
                              )
                            "
                            >{{ $t("SELECT_ALL") }}</a
                          >
                          |
                          <a
                            class="text-primary"
                            @click="filters.children.roomTypeId = []"
                            >{{ $t("UN_SELECT_ALL") }}</a
                          >
                        </p>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                          color="primary"
                          v-if="index === 0"
                          v-bind="item.attrs"
                          :input-value="item.selected"
                          close
                          @click:close="
                            removeChips(index, filters.children.roomTypeId)
                          "
                        >
                          <span class="text-truncate-min text-truncate">{{
                            item.text
                          }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ filters.children.roomTypeId.length - 1 }})</span
                        >
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div class="w-20 pr-2 mb-3">
                    <label>
                      {{ $t("SALE_PACKAGE_DERIVED") }}
                    </label>
                    <v-autocomplete
                      item-text="text"
                      item-value="value"
                      :items="ratePlans"
                      v-model="filters.children.ratePlanId"
                      class="w-100"
                      outlined
                      dense
                      :multiple="true"
                      chips
                    >
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1">
                          <a
                            class="text-primary"
                            @click="
                              filters.children.ratePlanId = ratePlans.map(
                                (e) => e.value
                              )
                            "
                            >{{ $t("SELECT_ALL") }}</a
                          >
                          |
                          <a
                            class="text-primary"
                            @click="filters.children.ratePlanId = []"
                            >{{ $t("UN_SELECT_ALL") }}</a
                          >
                        </p>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                          color="primary"
                          v-if="index === 0"
                          v-bind="item.attrs"
                          :input-value="item.selected"
                          close
                          @click:close="
                            removeChips(index, filters.children.ratePlanId)
                          "
                        >
                          <span class="text-truncate-min text-truncate">{{
                            item.text
                          }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ filters.children.ratePlanId.length - 1 }})</span
                        >
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div class="w-20 mb-3">
                    <label>
                      {{ $t("SALE_CHANNEL_DERIVED") }}
                    </label>
                    <v-autocomplete
                      item-text="text"
                      item-value="value"
                      :items="otas"
                      v-model="filters.children.otaId"
                      class="w-100"
                      outlined
                      dense
                      :multiple="true"
                      chips
                    >
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1">
                          <a
                            class="text-primary"
                            @click="
                              filters.children.otaId = otas.map((e) => e.value)
                            "
                            >{{ $t("SELECT_ALL") }}</a
                          >
                          |
                          <a
                            class="text-primary"
                            @click="filters.children.otaId = []"
                            >{{ $t("UN_SELECT_ALL") }}</a
                          >
                        </p>
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip
                          color="primary"
                          v-if="index === 0"
                          v-bind="item.attrs"
                          :input-value="item.selected"
                          close
                          @click:close="
                            removeChips(index, filters.children.otaId)
                          "
                        >
                          <span class="text-truncate-min text-truncate">{{
                            item.text
                          }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                          >(+{{ filters.children.otaId.length - 1 }})</span
                        >
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
              </b-collapse>
            </div>
            <div v-if="!isLoading" class="tables-scroll-x-container" :style="{ 'max-height': maxHeight + 'px' }" @scroll="listFomulaLoadMores">
              <table class="tables-scroll-x">
                <thead>
                  <tr>
                    <th class="sticky-column left">{{ $t("N_O") }}</th>
                    <th class="sticky-column left text-left">{{ $t("MASTER_PRODUCT") }} (M)</th>
                    <th class="sticky-column left text-left">{{ $t("DERIVED_PRODUCT") }} (C)</th>
                    <th class="text-left mw-150">{{ $t("PRICE_FORMULA") }}</th>
                    <th class="cw-60 text-center">{{ $t("PRICE") }}</th>
                    <th
                      class="cw-60 text-center"
                      v-for="(restriction, idx) in filteredRestrictions"
                      :key="'restriction3Ids'+idx"
                    >
                      {{ restriction.shortText }}
                    </th>
                    <th class="sticky-column right">{{ $t("ACTION") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dataRoomRate" :key="'dataRoomRate'+item.index">
                    <td class="sticky-column left text-center px-1">{{ item.index }}</td>
                    <td class="sticky-column left px-1">
                      <div class="cut-text" :title="item.MASTER_PRODUCT">
                        {{item.MASTER_PRODUCT}}
                      </div>
                    </td>
                    <td class="sticky-column left px-1">
                      <div class="cut-text" :title="item.DERIVED_PRODUCT">
                      {{item.DERIVED_PRODUCT}}
                      </div>
                    </td>
                    <td class="mw-150 px-1" v-html="item.PRICE_FORMULA"></td>
                    <td class="cw-60 text-center px-2">
                        <svg class="cursor-default" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                          <path fill="#335073" :d="(item.restrictionType & bitSetupPrice) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                          'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                        </svg>
                    </td>
                    <td
                      v-for="(restriction, idx) in filteredRestrictions"
                      :key="'rootRestriction1Table'+idx"
                      class="cw-60 text-center px-2"
                    >
                      <svg class="cursor-default" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="#335073" :d="(item.restrictionType & restriction.bitFlag) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                        'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                      </svg>
                    </td>
                    <td class="sticky-column right text-right text-nowrap px-1">
                      <span class="ml-1" :title="$t('EDIT')" @click="editRecord(item)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="20" viewBox="0 0 36 20">
                          <rect x="0.5" y="0.5" width="34" height="19" rx="2" fill="none" stroke="#003e94" stroke-width="1"/>
                          <g transform="translate(9.5, 1.5)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                              <path fill="#003e94" d="M20.71 7.04c.39-.39.39-1.04 0-1.41l-2.34-2.34c-.37-.39-1.02-.39-1.41 0l-1.84 1.83l3.75 3.75M3 17.25V21h3.75L17.81 9.93l-3.75-3.75z"/>
                            </svg>
                          </g>
                        </svg>
                      </span>
                      <span class="ml-1" :title="$t('SET_UP_FORMULAR_BY_DATE_RANGE')" @click="calculateFormulaByDate(item.derivationId)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="20" viewBox="0 0 36 20">
                          <rect x="0.5" y="0.5" width="34" height="19" rx="2" fill="none" stroke="black" stroke-width="1"/>
                          <g transform="translate(9.5, 1.5)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                              <path fill="black" d="M9 10H7v2h2zm4 0h-2v2h2zm4 0h-2v2h2zm2-7h-1V1h-2v2H8V1H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V8h14z"/>
                            </svg>
                          </g>
                        </svg>
                      </span>
                      <span class="ml-1" :title="$t('DELETE')" @click="
                        $refs.deleteDialogComponent.open({
                          derivationId: item.derivationId,
                        })
                      ">
                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="20" viewBox="0 0 36 20">
                          <rect x="0.5" y="0.5" width="34" height="19" rx="2" fill="none" stroke="red" stroke-width="1"/>
                          <g transform="translate(9.5, 1.5)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                              <path fill="red" d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6z" />
                            </svg>
                          </g>
                        </svg>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-if="dataRoomRateLoading" class="text-center py-2" style="position:sticky; left: 0;">
                <v-progress-circular
                  :width="2"
                  color="gray"
                  indeterminate
                ></v-progress-circular>
              </div>
            </div>
            <p v-if="!isLoading && dataRoomRate.length == 0" class="text-center py-3">{{$t("HAS_NO_DATA")}}</p>
          </div>
        </div>
      </div>
    </div>
    <v-btn
      v-if="!isNote"
      color="primary"
      dark
      bottom
      left
      class="btn-note mb-1"
      @click="
        isNote = true;
        maxHeight = maxHeight - 80;
      "
      style="z-index: 6; width:36px; left:270px;"
    >
      <i class="icon-category fs-16"></i>
    </v-btn>
    <v-col
      ref="notes"
      class="border-top d-flex align-items-center"
      v-if="isNote"
      style="position: absolute; bottom: 0; background: #fff; z-index: 8"
    >
      <ul class="tools-icon-description">
        <li v-for="(restriction, index) in restrictions" :key="'icon-description'+index">
          <span
            class="font-weight-bold text-uppercase text-nowrap"
            :style="{ fontSize: '11px' }"
            >{{ restriction.shortText }}:</span
          >
          <span class="text-primary pl-2 text-nowrap">{{
            restriction.text
          }}</span>
        </li>
        <li>
          <span class="d-flex">
          <v-icon color="primary" size="24" style="margin-top: -2px;">
            mdi-checkbox-marked
          </v-icon>
          <span class="text-primary text-nowrap">{{
            $t('APPLY')
          }}</span>
          </span>
        </li>
        <li>
          <span class="d-flex">
            <v-icon color="primary" size="24" style="margin-top: -2px;">
              mdi-checkbox-blank-outline
            </v-icon>
            <span class="text-primary text-nowrap">{{$t('NOT_APPLY')}}</span>
          </span>
        </li>
      </ul>
      <v-btn
        class="ml-3 py-5"
        dark
        small
        color="primary"
        @click="
          isNote = false;
          maxHeight = maxHeight + 80;
         "
      >
        <i class="icon-expand_more fs-16"></i>
      </v-btn>
    </v-col>
    <delete-dialog
      @deleteItem="removeFormula"
      :maxWidth="325"
      ref="deleteDialogComponent"
    >
      <span slot="title">{{ $t("CONFIRM_DELETE_FORMULA") }}?</span>
    </delete-dialog>
    <v-navigation-drawer v-model="isSetup" absolute temporary right width="760">
      <div class="position-sticky sticky-top bg-white">
        <div class="d-flex" style="height: 60px">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="fs-18">{{ $t("SET_UP_FORMULAR") }}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <div class="text-right px-3 pt-3 d-flex">
            <v-btn
              class="mt-0 mr-2"
              color="error"
              @click="isSetup = false"
              small
            >
              {{ $t("_LOGIN.CANCEL") }}
            </v-btn>
            <v-btn :disabled="isConfirmLoading" class="mt-0" color="primary" small @click="configFomular()">
              {{ $t("SAVE") }}
            </v-btn>
          </div>
        </div>
        <v-divider class="mt-0"></v-divider>
      </div>
      <v-progress-linear
        color="secondary"
        indeterminate
        rounded
        height="3"
        v-if="isConfirmLoading"
      ></v-progress-linear>
      <div class="border m-3 mt-0 rounded-lg">
        <p class="font-weight-bold px-3 pt-3 mb-0">{{ $t("CONFIG_BY") }}</p>
        <div class="px-3">
          <v-radio-group v-model="configBy" row @input="$forceUpdate()">
            <v-radio :label="$t('ROOM_TYPE')" value="ROOM_TYPE"></v-radio>
            <v-radio :label="$t('SALE_PACKAGE')" value="RATE_PLAN"></v-radio>
            <v-radio :label="$t('SALE_CHANNEL')" value="OTA"></v-radio>
            <v-radio :label="$t('CUSTOM')" value="CUSTOM"></v-radio>
          </v-radio-group>
        </div>
        <v-form ref="formNew">
          <div class="my-3">
            <div class="mb-3">
              <div class="font-weight-bold bg-light px-3 py-3">
                {{ $t("MASTER_PRODUCT") }} (M)
              </div>
              <div class="px-3 pt-3">
                <div>
                  <div
                    class="mb-2 d-flex align-items-center"
                    v-if="configBy === 'ROOM_TYPE' || configBy === 'CUSTOM'"
                  >
                    <label class="w-20 mr-2 text-right">
                      {{ $t("ROOM_TYPE") }}
                    </label>
                    <v-autocomplete
                      ref="mRoomTypeId"
                      @input="changeProperty()"
                      v-if="configBy === 'ROOM_TYPE' || configBy === 'CUSTOM'"
                      class="v-requied"
                      item-text="text"
                      item-value="value"
                      :items="roomTypes"
                      v-model="master.roomTypeId"
                      style="width: 200px"
                      :rules="ruleRequiedNoMess"
                      outlined
                      dense
                      :multiple="false"
                    >
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div
                    class="mb-2 d-flex align-items-center"
                    v-if="configBy === 'RATE_PLAN' || configBy === 'CUSTOM'"
                  >
                    <label class="w-20 mr-2 text-right">
                      {{ $t("SALE_PACKAGE") }}
                    </label>
                    <v-autocomplete
                      ref="mRatePlanId"
                      @input="changeProperty()"
                      v-if="configBy === 'RATE_PLAN' || configBy === 'CUSTOM'"
                      class="v-requied"
                      item-text="text"
                      item-value="value"
                      :items="ratePlans"
                      v-model="master.ratePlanId"
                      style="width: 200px"
                      :rules="ruleRequiedNoMess"
                      outlined
                      dense
                      :multiple="false"
                    >
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </div>
                  <div
                    class="mb-2 d-flex align-items-center"
                    v-if="configBy === 'OTA' || configBy === 'CUSTOM'"
                  >
                    <label class="w-20 mr-2 text-right">
                      {{ $t("SALE_CHANNEL") }}
                    </label>
                    <v-autocomplete
                      ref="mOtaId"
                      @input="changeProperty()"
                      v-if="configBy === 'OTA' || configBy === 'CUSTOM'"
                      class="v-requied"
                      item-text="text"
                      item-value="value"
                      :items="otas"
                      v-model="master.otaId"
                      style="width: 200px"
                      :rules="ruleRequiedNoMess"
                      outlined
                      dense
                      :multiple="false"
                    >
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="font-weight-bold bg-light px-3 py-3">
                {{ $t("DERIVED_PRODUCT") }} (C)
              </div>
              <div class="px-3 pt-3">
                <div
                  class="mb-2 d-flex align-items-center"
                  v-if="configBy === 'ROOM_TYPE' || configBy === 'CUSTOM'"
                >
                  <label class="w-20 mr-2 text-right">
                    {{ $t("ROOM_TYPE") }}
                  </label>
                  <v-autocomplete
                    ref="cRoomTypeId"
                    v-if="configBy === 'ROOM_TYPE' || configBy === 'CUSTOM'"
                    class="v-requied"
                    item-text="text"
                    item-value="value"
                    :items="
                      roomTypes.filter(
                        (e) =>
                          (configBy === 'ROOM_TYPE' &&
                            e.value !== master.roomTypeId) ||
                          configBy !== 'ROOM_TYPE'
                      )
                    "
                    v-model="children.roomTypeId"
                    style="width: 200px"
                    :rules="ruleRequiedArrNoMess"
                    outlined
                    dense
                    multiple
                    chips
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1">
                        <a
                          class="text-primary"
                          @click="
                            children.roomTypeId = roomTypes.map((e) => e.value)
                          "
                          >{{ $t("SELECT_ALL") }}</a
                        >
                        |
                        <a
                          class="text-primary"
                          @click="children.roomTypeId = []"
                          >{{ $t("UN_SELECT_ALL") }}</a
                        >
                      </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0 || index === 1"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="removeChips(index, children.roomTypeId)"
                      >
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 2" class="grey--text caption"
                        >(+{{ children.roomTypeId.length - 2 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </div>
                <div
                  class="mb-2 d-flex align-items-center"
                  v-if="configBy === 'RATE_PLAN' || configBy === 'CUSTOM'"
                >
                  <label class="w-20 mr-2 text-right">
                    {{ $t("SALE_PACKAGE") }}
                  </label>
                  <v-autocomplete
                    ref="cRatePlanId"
                    v-if="configBy === 'RATE_PLAN' || configBy === 'CUSTOM'"
                    class="v-requied"
                    item-text="text"
                    item-value="value"
                    :items="
                      ratePlans.filter(
                        (e) =>
                          (configBy === 'RATE_PLAN' &&
                            e.value !== master.ratePlanId) ||
                          configBy !== 'RATE_PLAN'
                      )
                    "
                    v-model="children.ratePlanId"
                    style="width: 200px"
                    :rules="ruleRequiedArrNoMess"
                    outlined
                    dense
                    multiple
                    chips
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1">
                        <a
                          class="text-primary"
                          @click="
                            children.ratePlanId = ratePlans.map((e) => e.value)
                          "
                          >{{ $t("SELECT_ALL") }}</a
                        >
                        |
                        <a
                          class="text-primary"
                          @click="children.ratePlanId = []"
                          >{{ $t("UN_SELECT_ALL") }}</a
                        >
                      </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0 || index === 1"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="removeChips(index, children.ratePlanId)"
                      >
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 2" class="grey--text caption"
                        >(+{{ children.ratePlanId.length - 2 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </div>
                <div
                  class="mb-2 d-flex align-items-center"
                  v-if="configBy === 'OTA' || configBy === 'CUSTOM'"
                >
                  <label class="w-20 mr-2 text-right">
                    {{ $t("SALE_CHANNEL") }}
                  </label>
                  <v-autocomplete
                    ref="cOtaId"
                    v-if="configBy === 'OTA' || configBy === 'CUSTOM'"
                    class="v-requied"
                    item-text="text"
                    item-value="value"
                    :items="
                      otas.filter(
                        (e) =>
                          (configBy === 'OTA' && e.value !== master.otaId) ||
                          configBy !== 'OTA'
                      )
                    "
                    v-model="children.otaId"
                    style="width: 200px"
                    :rules="ruleRequiedArrNoMess"
                    outlined
                    dense
                    multiple
                    chips
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1">
                        <a
                          class="text-primary"
                          @click="children.otaId = otas.map((e) => e.value)"
                          >{{ $t("SELECT_ALL") }}</a
                        >
                        |
                        <a class="text-primary" @click="children.otaId = []">{{
                          $t("UN_SELECT_ALL")
                        }}</a>
                      </p>
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <v-chip
                        color="primary"
                        v-if="index === 0 || index === 1"
                        v-bind="item.attrs"
                        :input-value="item.selected"
                        close
                        @click:close="removeChips(index, children.otaId)"
                      >
                        <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 2" class="grey--text caption"
                        >(+{{ children.otaId.length - 2 }})</span
                      >
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </div>
              </div>
            </div>
          </div>
        </v-form>
      </div>
      <div class="border m-3 mt-0 rounded-lg">
        <div class="p-3">
          <v-checkbox
            class="m-0 p-0"
            :label="$t('PRICE')"
            v-model="showPrice"
          ></v-checkbox>
        </div>
        <div v-if="showPrice">
          <div class="d-flex justify-content-between bg-light p-3">
            <div class="font-weight-bold">
              {{ $t("PRICE_CALCULATION_FORMULA") }}
            </div>
            <span @click="seeMoreFomular = !seeMoreFomular"
              ><u class="text-primary pointer">{{
                seeMoreFomular == 0
                  ? $t("SHOW_MORE_FOMULA")
                  : $t("_ROOM_SALE.UNEXPAND")
              }}</u></span
            >
          </div>
          <div class="py-3">
            <div class="p-3" :class="fomularSelected == '0' ? 'bg-action' : ''">
              <div class="d-flex justify-content-between">
                <v-radio-group
                  class="m-0 p-0 align-center"
                  v-model="fomularSelected"
                >
                  <v-radio value="0" class="m-0 p-0"></v-radio>
                </v-radio-group>
                <rate-derivation
                  :isEdit="true"
                  :rateAdditional="itemAdd.rateAdditional"
                  @changeRateAdditional="(val)=> itemAdd.rateAdditional = val"
                  :rateIndex="itemAdd.rateIndex"
                  @changeRateIndex="(val)=> itemAdd.rateIndex = val"
                  :rateSupplement="itemAdd.rateSupplement"
                  @changeRateSupplement="(val)=> itemAdd.rateSupplement = val"
                  :roomRateDerivationsDenominatorList="itemAdd.roomRateDerivationsDenominatorList"
                  @changeRateDerivationsDenominatorList="(val)=> itemAdd.roomRateDerivationsDenominatorList = val"
                ></rate-derivation>
              </div>
            </div>
            <div
              class="p-3"
              v-if="seeMoreFomular"
              :class="fomularSelected == '1' ? 'bg-action' : ''"
            >
              <div class="d-flex justify-content-between">
                <v-radio-group
                  class="m-0 p-0 align-center"
                  v-model="fomularSelected"
                >
                  <v-radio value="1" class="m-0 p-0"></v-radio>
                </v-radio-group>
                <rate-derivation
                  :isEdit="true"
                  :rateAdditional="itemAddWithDenominator.rateAdditional"
                  @changeRateAdditional="(val)=> itemAddWithDenominator.rateAdditional = val"
                  :rateIndex="itemAddWithDenominator.rateIndex"
                  @changeRateIndex="(val)=> itemAddWithDenominator.rateIndex = val"
                  :rateSupplement="itemAddWithDenominator.rateSupplement"
                  @changeRateSupplement="(val)=> itemAddWithDenominator.rateSupplement = val"
                  :roomRateDerivationsDenominatorList="itemAddWithDenominator.roomRateDerivationsDenominatorList"
                  @changeRateDerivationsDenominatorList="(val)=> itemAddWithDenominator.roomRateDerivationsDenominatorList = val"
                ></rate-derivation>
              </div>
            </div>
          </div>
        </div>
      </div>
      <v-row class="m-3">
        {{ $t("SELECT_TYPE_RESTRICTION") }}
      </v-row>
      <div class="border m-3 rounded-lg">
        <v-row class="px-3">
          <v-col
            cols="4"
            v-for="(restriction, index) in restrictions.slice(-1).concat(restrictions.slice(0, -1))"
            :key="'TYPE_RESTRICTION'+index"
          >
            <div class="text-nowrap">
              <v-checkbox
                class="m-0 p-0"
                :label="restriction.text"
                :input-value="isChecked(restrictionType, restriction.bitFlag)"
                @change="
                  (checked) =>
                    toggleRestrictionSetup(checked, restriction.bitFlag)
                "
              ></v-checkbox>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="m-3 text-danger">{{ $t("NOTE_DERIVED") }}</div>
      <div
        class="m-3"
        v-if="
          configBy !== 'CUSTOM' &&
          (master.roomTypeId || master.ratePlanId || master.otaId)
        "
      >
        {{ $t("_REQUEST_DETAIL.NOTE") }}:
        {{
          $t("TOOLTIP_BASE_" + configBy, {
            value:
              configBy === "ROOM_TYPE"
                ? roomTypes.find((e) => e.value === master.roomTypeId).text
                : configBy === "RATE_PLAN"
                ? ratePlans.find((e) => e.value === master.ratePlanId).text
                : configBy === "OTA"
                ? otas.find((e) => e.value === master.otaId).text
                : "",
          })
        }}
      </div>
      <div v-if="showDialog" class="fullscreen-overlay" @click.self="showDialog = false">
        <v-card class="alert-card p-0" width="400" style="border-radius: 5px;">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title 
            class="text-primary fs-15 d-block px-2 py-3" 
            style="background: #e2e9f3; border-top-left-radius: 5px; border-top-right-radius: 5px;"
            >
              <strong>{{$t('NOTIFICATION')}}</strong>
            </v-toolbar-title>
          </v-toolbar>
          <div class="content-update">
            <label class="s-label">{{dialogMessage}}</label>
            <div class="mt-3 d-flex justify-content-end">
              <div class="w-100 mr-1">
              </div>
              <div class="w-100 ml-1">
                <v-btn block color="primary" @click="showDialog = false">{{$t("CLOSE")}}</v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="isConfirm"
      absolute
      temporary
      right
      width="1000"
    >
      <div class="position-sticky sticky-top bg-white">
        <div class="d-flex" style="height: 60px">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="fs-18">{{$t("LIST_FORMULAR_UPDATE")}}</span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <div class="text-right px-3 pt-3 d-flex">
            <v-btn
              class="mt-0 mr-2 bg-secondary text-white"
              @click="
                isConfirm = false;
                isSetup = true;
              "
              small
            >
              {{ $t("BACK") }}
            </v-btn>
            <v-btn
              class="mt-0"
              color="primary"
              small
              :disabled="onSaving"
              @click="saveFomularSetUp()"
            >
              {{ $t("CONFIRM") }}
            </v-btn>
          </div>
        </div>
        <v-divider class="mt-0"></v-divider>
      </div>
      <v-progress-linear
        color="secondary"
        indeterminate
        rounded
        height="3"
        v-if="onSaving"
        class="mb-1"
      ></v-progress-linear>
      <div class="mb-1 detail-fomula">
        <div class="tables-scroll-x-container" style="max-height:calc(100vh - 170px);" @scroll="loadMores">
          <table class="tables-scroll-x confirm-fomular">
            <thead>
              <tr>
                <th class="sticky-column left">{{ $t("N_O") }}</th>
                <th class="sticky-column left text-left">{{ $t("MASTER_PRODUCT") }} (M)</th>
                <th class="sticky-column left text-left">{{ $t("DERIVED_PRODUCT") }} (C)</th>
                <th class="sticky-column left text-left">{{ $t("CHANGE") }}</th>
                <th class="text-left mw-150">{{ $t("PRICE_FORMULA") }}</th>
                <th class="cw-60 text-center">{{ $t("PRICE") }}</th>
                <th
                  class="cw-60 text-center"
                  v-for="(restriction, idx) in restrictions"
                  :key="'restrictionTitle'+idx"
                >
                  {{ restriction.shortText }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, idx) in listConfirm">
                <tr :key="'listConfirmOld'+idx">
                  <td rowspan="2" class="sticky-column left text-center px-1">{{ idx + 1 }}</td>
                  <td rowspan="2" class="px-1 sticky-column left ">
                    <div 
                      class="cut-text"
                      :title="item.MASTER_PRODUCT "
                    >
                      {{item.MASTER_PRODUCT}}
                    </div>
                  </td>
                  <td rowspan="2" class="sticky-column left px-1">
                    <div 
                      class="cut-text"
                      :title="item.DERIVED_PRODUCT"
                    >
                      {{item.DERIVED_PRODUCT}}
                    </div>
                  </td>
                  <td class="sticky-column left text-center px-2 old-fomula text-nowrap">
                    {{$t("BEFORE")}}
                  </td>
                  <td class="old-fomula px-2">
                    <div
                      class="txt-nowrap d-flex align-center"
                      v-html="item.PRICE_FORMULA_OLD"
                    ></div>
                  </td>
                  <td class="old-fomula px-2">
                    <svg class="cursor-default" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path fill="#335073" :d="(item.restrictionTypeOld & bitSetupPrice) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                      'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                    </svg>
                  </td>
                  <td class="old-fomula px-2" v-for="(restriction, idx1) in restrictions" :key="'restriction1Checkbox'+idx1">
                    <svg
                      class="cursor-default"
                      xmlns="http://www.w3.org/2000/svg" 
                      width="24" 
                      height="24" 
                      viewBox="0 0 24 24"
                    >
                      <path fill="#335073" :d="(item.restrictionTypeOld & restriction.bitFlag) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                      'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                    </svg>
                  </td>
                </tr>
                <tr :key="'listConfirmNew'+idx">
                  <td class="sticky-column left after-change text-center px-2 text-nowrap" :class="item.background">
                    {{$t("AFTER")}}
                  </td>
                  <td class="px-2" :class="item.background">
                    <div
                      class="txt-nowrap d-flex align-center"
                      v-html="item.PRICE_FORMULA"
                    ></div>
                  </td>
                  <td class="px-2" :class="item.background">
                    <svg class="cursor-default" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path fill="#335073" :d="(item.restrictionType & bitSetupPrice) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                      'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                    </svg>
                  </td>
                  <td class="px-2" :class="item.background" v-for="(restriction, idx1) in restrictions" :key="'restriction2Checkbox'+idx1">
                    <svg
                      class="cursor-default"
                      xmlns="http://www.w3.org/2000/svg" 
                      width="24" 
                      height="24" 
                      viewBox="0 0 24 24"
                    >
                      <path fill="#335073" :d="(item.restrictionType & restriction.bitFlag) !== 0 ? 'm10 17l-5-5l1.41-1.42L10 14.17l7.59-7.59L19 8m0-5H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2' :
                      'M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z'"/>
                    </svg>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <div v-if="isProcess" class="text-center py-2" style="position:sticky; left: 0;">
            <v-progress-circular
              :width="2"
              color="gray"
              indeterminate
            ></v-progress-circular>
          </div>
        </div>
      </div>
      <div class="mx-3 my-2 text-danger">{{ $t("NOTE_DERIVED") }}</div>
      <div class="d-flex justify-content-start">
        <div class="d-flex"><span class="fomula-note new-fomula mx-1"></span>{{$t("NEW_FORMULA")}}</div>
        <div class="d-flex mx-2"><span class="fomula-note change-fomula mx-1"></span>{{$t("MODIFIED_FORMULA")}}</div>
        <div class="d-flex"><span class="fomula-note del-fomula mx-1"></span>{{$t("DELETED_FORMULA")}}</div>
      </div>
    </v-navigation-drawer>
    <v-alert
      dense
      color="orange"
      type="info"
      class="alert-custom warning-alert p-3"
      v-if="message"
    >
      <span>{{message}}</span>
    </v-alert>
  </div>
</template>

<script>
import { _alert } from "@/_helpers/function.js";
import DatePicker from "@/components/Utils/DatePicker.vue";

import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import moment from "moment";

//
import { masterRateService } from "@/_services/MasterRate/masterRate.service.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import numberInput from "@/components/Utils/Number-input.vue";
import RateDerivation from '../Utils/RateDerivation.vue';

export default {
  components: {
    "delete-dialog": DeleteDialog,
    "date-picker": DatePicker,
    Treeselect,
    "number-ptd": numberInput,
    "rate-derivation": RateDerivation,
  },
  data() {
    return {
      filters: {
        master: {
          roomTypeId: [],
          ratePlanId: [],
          otaId: [],
          restrictionId: [],
        },
        children: {
          roomTypeId: [],
          ratePlanId: [],
          otaId: [],
          restrictionId: [],
        },
      },
      isLoading: false,
      systemLang: this.$i18n.locale,
      ListProduceMaster: [],
      listProduce: [],
      selectedProduce: [],
      dataMasterRate: [],

      dataRoomRateFormula: [],
      dataRoomRate: [],
      dataRoomRateTmp: [],
      dataRoomRateLoading: false,
      allRoomRate: [],
      roomRateMaster: [],
      roomRateChild: [],
      multiplierOption: {
        prefix: "",
        locale: "vi",
        length: 5,
        precision: 2,
      },
      itemAdd: {
        idMaster: null,
        idChild: null,
        rateIndex: 1,
        rateSupplement: 0,
        rateAdditional: 0,
      },
      isSetup: false,
      roomTypes: [],
      ratePlans: [],
      otas: [],
      master: {
        roomTypeId: null,
        ratePlanId: null,
        otaId: null,
      },
      children: {
        roomTypeId: [],
        ratePlanId: [],
        otaId: [],
      },
      configBy: "ROOM_TYPE",
      restrictions: [
        {
          text: this.$t("minStay"),
          value: "minStay",
          shortText: "MS",
          bitFlag: 32,
        },
        {
          text: this.$t("maxStay"),
          value: "maxStay",
          shortText: "MXS",
          bitFlag: 64,
        },
        {
          text: this.$t("minStayArrival"),
          value: "minStayArrival",
          shortText: "MSA",
          bitFlag: 256,
        },
        {
          text: this.$t("maxStayArrival"),
          value: "maxStayArrival",
          shortText: "MXSA",
          bitFlag: 512,
        },
        {
          text: this.$t("minBookingWindow"),
          value: "minBookingWindow",
          shortText: "MBW",
          bitFlag: 8,
        },
        {
          text: this.$t("maxBookingWindow"),
          value: "maxBookingWindow",
          shortText: "MXBW",
          bitFlag: 16,
        },
        {
          text: this.$t("minBookingWindowByHour"),
          value: "minBookingWindowByHour",
          shortText: "MBWH",
          bitFlag: 4096,
        },
        {
          text: this.$t("maxBookingWindowByHour"),
          value: "maxBookingWindowByHour",
          shortText: "XBWH",
          bitFlag: 8192,
        },
        {
          text: this.$t("exactStay"),
          value: "exactStay",
          shortText: "ES",
          bitFlag: 128,
        },
        {
          text: this.$t("exactStayArrival"),
          value: "exactStayArrival",
          shortText: "ESA",
          bitFlag: 1024,
        },
        {
          text: this.$t("closedOnArrival"),
          value: "closedOnArrival",
          shortText: "CTA",
          bitFlag: 2,
        },
        {
          text: this.$t("closedOnDeparture"),
          value: "closedOnDeparture",
          shortText: "CTD",
          bitFlag: 4,
        },
        {
          text: this.$t("closed"),
          value: "closed",
          shortText: "SS",
          bitFlag: 1,
        },
      ],
      modifiedRestrictions: [],
      showPrice: 0,
      seeMoreFomular: 0,
      fomularSelected: "0",
      isNote: true,
      maxHeight: 330,
      restrictionType: 0,
      roomRateDerivationsDenominatorList: [],
      tmpBody: null,
      listConfirm: [],
      isConfirm: false,
      isConfirmLoading: false,
      itemAddWithDenominator: {
        idMaster: null,
        idChild: null,
        rateIndex: 1,
        rateSupplement: 0,
        rateAdditional: 0,
        roomRateDerivationsDenominatorList: [],
      },
      showDialog: false,
      dialogMessage: "",
      bitSetupPrice: 2048,
      isEditRecord: false,
      fomulaType: {
        addNew: 0,
        willChange: 1,
        willDelete: 2,
        noChange: 3
      },
      isDeleting: false,
      isProcess: false,
      listConfirmTmp: [],
      showMoreFilter: false,
      pagination: {
        page: 0,
        totalPage: 0,
        perPage: 20
      },
      confirmPagination: {
        page: 0,
        totalPage: 0,
        perPage: 20
      },
      onSaving: false,
      message: null,
    };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  computed: {
    filteredRestrictions() {
      if (this.filters.master.restrictionId.length === 0) {
        return this.restrictions;
      }
      return this.restrictions.filter((e) =>
        this.filters.master.restrictionId.includes(e.value)
      );
    },
    numberSearch() {
      let num = 0;
      if(this.filters.children.roomTypeId.length > 0) {
        num += 1;
      }
      if(this.filters.children.ratePlanId.length > 0) {
        num += 1;
      }
      if(this.filters.children.otaId.length > 0) {
        num += 1;
      }
      return num;
    }
  },
  created() {
    this.currency = this.priceOptionsVi.suffix;
    this.getRoomRateWithFormula();
  },
  watch: {
    showPrice(old, newVal) {
      if (newVal) {
        this.restrictionType &= ~this.bitSetupPrice;
      } else {
        this.restrictionType |= this.bitSetupPrice;
        if (this.itemAddWithDenominator.roomRateDerivationsDenominatorList.length == 0) {
          this.getRoomRateDerivationsDenominatorList();
        }
      }
    },
    isSetup(old, newVal) {
      if (old === false && newVal === true) {
        this.$refs.formNew.resetValidation();
      }
    },
    configBy() {
      if (!this.isEditRecord) {
        this.master.roomTypeId = null;
        this.master.ratePlanId = null;
        this.master.otaId = null;
        this.$refs.formNew.resetValidation();
      }
      this.isEditRecord = false;
    },
  },
  methods: {
    showMore() {
      this.showMoreFilter = !this.showMoreFilter;
      if (this.showMoreFilter) {
        this.maxHeight -= 60;
      } else {
        this.maxHeight += 60;
      }
    },
    loadMores(event) {
      const container = event.target;
      if (this.isProcess || this.confirmPagination.page == this.confirmPagination.totalPage) return;
      if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
        this.isProcess = true;
        setTimeout(() => {
          this.$set(this,'listConfirm', [...this.listConfirm, ...this.listConfirmTmp.slice(
            this.confirmPagination.page * this.confirmPagination.perPage, 
            (this.confirmPagination.page + 1) * this.confirmPagination.perPage
          )]);
          this.confirmPagination.page += 1;
          this.isProcess = false;
        }, 1500);
      }
    },
    listFomulaLoadMores(event) {
      const container = event.target;
      if (this.dataRoomRateLoading || this.pagination.page == this.pagination.totalPage) return;
      if (container.scrollTop + container.clientHeight >= (container.scrollHeight - 20 - (this.dataRoomRateLoading ? 60 : 0))) {
        this.dataRoomRateLoading = true;
        setTimeout(() => {
          this.$set(this,'dataRoomRate', [...this.dataRoomRate, ...this.dataRoomRateTmp.slice(
            this.pagination.page * this.pagination.perPage, 
            (this.pagination.page + 1) * this.pagination.perPage
          )]);
          this.pagination.page += 1;
          this.dataRoomRateLoading = false;
        }, 1500);
      }
    },
    editRecord(fomula) {
      this.isEditRecord = true;
      this.$refs.formNew.resetValidation();
      this.configBy = 'CUSTOM';
      this.children.roomTypeId = [];
      this.children.roomTypeId.push(fomula.roomTypeId);
      this.children.ratePlanId = [];
      this.children.ratePlanId.push(fomula.ratePlanId);
      this.children.otaId = [];
      this.children.otaId.push(fomula.otaId);
      this.itemAdd.rateIndex = 1;
      this.itemAdd.rateSupplement = 0;
      this.itemAdd.rateAdditional = 0;
      this.itemAddWithDenominator.rateIndex = 1;
      this.itemAddWithDenominator.rateSupplement = 0;
      this.itemAddWithDenominator.rateAdditional = 0;
      this.itemAddWithDenominator.roomRateDerivationsDenominatorList = [];
      this.restrictionType = fomula.restrictionType;
      this.showPrice = (fomula.restrictionType & this.bitSetupPrice) !== 0 ? 1 : 0;
      this.fomularSelected = "0";
      this.seeMoreFomular = 0;
      
      if (this.showPrice && fomula.roomRateDerivationsDenominatorList.length > 0) {
        this.fomularSelected = "1";
        this.seeMoreFomular = 1;
        this.itemAddWithDenominator.rateIndex = fomula.rateIndex;
        this.itemAddWithDenominator.rateSupplement = fomula.rateSupplement;
        this.itemAddWithDenominator.rateAdditional = fomula.rateAdditional;
        this.itemAddWithDenominator.roomRateDerivationsDenominatorList = fomula.roomRateDerivationsDenominatorList;
      }

      if (this.showPrice && fomula.roomRateDerivationsDenominatorList.length == 0) {
        this.itemAdd.rateIndex = fomula.rateIndex;
        this.itemAdd.rateSupplement = fomula.rateSupplement;
        this.itemAdd.rateAdditional = fomula.rateAdditional;
        this.getRoomRateDerivationsDenominatorList();
      }

      this.master.roomTypeId = fomula.master.roomTypeId;
      this.master.ratePlanId = fomula.master.ratePlanId;
      this.master.otaId = fomula.master.otaId;

      this.tmpBody = null;
      this.listConfirm = [];      
      this.showDialog = false;
      this.dialogMessage = '';
      this.isSetup = true;
      
      this.$forceUpdate();
    },
    onResize() {
      let viewPage = this.$refs.viewPage;
      let listOption = this.$refs.listOption;
      let options = this.$refs.options;
      let notes = this.$refs.notes;
      if(viewPage && listOption && options && notes) {
        this.maxHeight = viewPage.clientHeight - listOption.clientHeight - options.clientHeight - notes.clientHeight;
      }
    },
    getRoomRateDerivationsDenominatorList() {
      masterRateService.getRoomRateDerivationsDenominatorList().then((res) => {
        if (res.responseCode === 0) {
          res.data.forEach((item) => {
            if (item.length > 0) {
              this.itemAddWithDenominator.roomRateDerivationsDenominatorList = item;
            }
          });
        }
      });
    },
    custormInput() {
      return {
        suffix: `%`,
        locale: this.$i18n.locale,
        precision: 1,
      };
    },
    isChecked(restrictionType, bitFlag) {
      return (restrictionType & bitFlag) !== 0;
    },
    toggleRestrictionSetup(checked, bitFlag) {
      if (checked) {
        this.restrictionType += bitFlag;
      } else {
        this.restrictionType -= bitFlag;
      }
    },
    changeProperty() {
      if (this.configBy === "ROOM_TYPE") {
        this.children.roomTypeId = [];
      }
      if (this.configBy === "RATE_PLAN") {
        this.children.ratePlanId = [];
      }
      if (this.configBy === "OTA") {
        this.children.otaId = [];
      }
    },
    openPopupSetup() {
      this.$refs.formNew.resetValidation();
      this.isSetup = true;
      this.configBy = 'ROOM_TYPE';
      this.master.roomTypeId = null;
      this.master.ratePlanId = null;
      this.master.otaId = null;
      this.children.roomTypeId = [];
      this.children.ratePlanId = [];
      this.children.otaId = [];
      this.itemAdd.rateIndex = 1;
      this.itemAdd.rateSupplement = 0;
      this.itemAdd.rateAdditional = 0;
      this.restrictionType = 0;
      this.fomularSelected = "0";
      this.tmpBody = null;
      this.listConfirm = [];
      this.displayedRecords = [];
      this.itemAddWithDenominator.rateIndex = 1;
      this.itemAddWithDenominator.rateSupplement = 0;
      this.itemAddWithDenominator.rateAdditional = 0;
      this.itemAddWithDenominator.roomRateDerivationsDenominatorList = [];
      this.showPrice = 0;
      this.seeMoreFomular = 0;
      this.fomularSelected = "0";
      this.showDialog = false;
      this.dialogMessage = '';
      this.$forceUpdate();
    },
    getRoomRateWithFormula() {
      this.isLoading = true;
      this.dataRoomRate = [];
      this.pagination.page = 0;
      masterRateService.getRoomRateWithFormula().then((res) => {
        if (res.responseCode === 0) {
          this.dataRoomRateFormula = res.data;
          this.dataRoomRateFormula.forEach((item, index) => {
            item.index = index+1;
            item.MASTER_PRODUCT = item.master.roomTypeI18n.find((x) => x.lang == this.defaultI18n).name
                                + '-' +
                                  item.master.ratePlanI18n.find((x) => x.lang == this.defaultI18n).name
                                + '-' +
                                  item.master.otaI18n.find((x) => x.lang == this.defaultI18n).name;
            item.DERIVED_PRODUCT = item.roomTypeI18n.find((x) => x.lang == this.defaultI18n).name
                                + '-' +
                                  item.ratePlanI18n.find((x) => x.lang == this.defaultI18n).name
                                + '-' +
                                  item.otaI18n.find((x) => x.lang == this.defaultI18n).name;
            item.PRICE_FORMULA = '';
            if ((item.restrictionType & this.bitSetupPrice) != 0) {
              item.PRICE_FORMULA = this.generateHtmlString(item);
            }
          });
          this.dataRoomRateTmp = JSON.parse(
            JSON.stringify(this.dataRoomRateFormula)
          );
          
          if (this.dataRoomRateTmp.length > 0) {
            this.pagination.totalPage = Math.ceil(this.dataRoomRateTmp.length / this.pagination.perPage);
            this.dataRoomRate = this.dataRoomRateTmp.slice(
              this.pagination.page * this.pagination.perPage, 
              (this.pagination.page + 1) * this.pagination.perPage
            );
            this.pagination.page += 1;
         }
          this.getAllRoomRate();
        }
      });
    },
    search() {
      this.dataRoomRateTmp = this.dataRoomRateFormula.filter(
        (e) =>
          (this.filters.master.roomTypeId.length === 0 ||
            this.filters.master.roomTypeId.includes(e.master.roomTypeId)) &&
          (this.filters.master.ratePlanId.length === 0 ||
            this.filters.master.ratePlanId.includes(e.master.ratePlanId)) &&
          (this.filters.master.otaId.length === 0 ||
            this.filters.master.otaId.includes(e.master.otaId)) &&
          (this.filters.children.roomTypeId.length === 0 ||
            this.filters.children.roomTypeId.includes(e.roomTypeId)) &&
          (this.filters.children.ratePlanId.length === 0 ||
            this.filters.children.ratePlanId.includes(e.ratePlanId)) &&
          (this.filters.children.otaId.length === 0 ||
            this.filters.children.otaId.includes(e.otaId))
      );
      this.dataRoomRateTmp.forEach((item, index) => {
        item.index = index + 1;
      });
      this.pagination.page = 0;
      this.pagination.totalPage = Math.ceil(this.dataRoomRateTmp.length / this.pagination.perPage);
      this.dataRoomRate = this.dataRoomRateTmp.slice(
        this.pagination.page * this.pagination.perPage, 
        (this.pagination.page + 1) * this.pagination.perPage
      );
      this.pagination.page += 1;
    },
    saveFormula(item) {
      if (!this.$refs.formOld.validate()) return false;
      item.roomRateDerivationsDenominatorList = item.roomRateDerivationsDenominatorList.map(value => {
          const numValue = parseFloat(value);
          return !isNaN(numValue) && isFinite(numValue) ? numValue : 0;
      });
      const body = {
        derivationId: item.derivationId,
        children: [
          {
            ratePlanId: item.ratePlanId,
            roomTypeId: item.roomTypeId,
            otaId: item.otaId,
          },
        ],
        master: {
          ratePlanId: item.master.ratePlanId,
          roomTypeId: item.master.roomTypeId,
          otaId: item.master.otaId,
        },
        rateIndex: parseFloat(item.rateIndex),
        rateSupplement: +item.rateSupplement,
        rateAdditional: +item.rateAdditional,
        restrictionType: item.restrictionType,
        roomRateDerivationsDenominatorList:
          item.roomRateDerivationsDenominatorList,
      };
      masterRateService
        .saveFormulaItem(body)
        .then((res) => {
          if (res.responseCode === 0) {
            item.isEdit = false;
          }
          this.getRoomRateWithFormula();
          _alert(res, this.$t(res.data), false);
        })
        .finally(() => (this.isLoading = false));
    },
    configFomular() {
      if (!this.$refs.formNew.validate()) return false;

      if(this.restrictionType == 0) {
        this.dialogMessage = this.$t("NO_TYPE_SELECTED");
        this.showDialog = true;
        return;
      }
      let body = null;
      if (this.configBy === "ROOM_TYPE") {
        if (!this.master.roomTypeId) return;
        body = {
          derivationId: null,
          children: this.children.roomTypeId
            .filter((item) => item !== this.master.roomTypeId)
            .map((e) =>
              Object.assign(
                {},
                {
                  ratePlanId: null,
                  roomTypeId: e,
                  otaId: null,
                }
              )
            ),
          master: {
            ratePlanId: null,
            roomTypeId: this.master.roomTypeId,
            otaId: null,
          },
        };
        if (body.children.length === 0) return;
      } else if (this.configBy === "RATE_PLAN") {
        if (!this.master.ratePlanId) return;
        body = {
          derivationId: null,
          children: this.children.ratePlanId
            .filter((item) => item !== this.master.ratePlanId)
            .map((e) =>
              Object.assign(
                {},
                {
                  ratePlanId: e,
                  roomTypeId: null,
                  otaId: null,
                }
              )
            ),
          master: {
            ratePlanId: this.master.ratePlanId,
            roomTypeId: null,
            otaId: null,
          },
        };
        if (body.children.length === 0) return;
      } else if (this.configBy === "OTA") {
        if (!this.master.otaId) return;
        body = {
          derivationId: null,
          children: this.children.otaId
            .filter((item) => item !== this.master.otaId)
            .map((e) =>
              Object.assign(
                {},
                {
                  ratePlanId: null,
                  roomTypeId: null,
                  otaId: e,
                }
              )
            ),
          master: {
            ratePlanId: null,
            roomTypeId: null,
            otaId: this.master.otaId,
          },
        };
        if (body.children.length === 0) return;
      } else {
        if (
          !this.master.otaId ||
          !this.master.roomTypeId ||
          !this.master.ratePlanId ||
          this.children.otaId.length === 0 ||
          this.children.ratePlanId.length === 0 ||
          this.children.roomTypeId.length === 0
        )
          return;

        let arr = [];
        this.children.roomTypeId.forEach((rt) => {
          this.children.ratePlanId.forEach((rp) => {
            this.children.otaId.forEach((ot) => {
              arr.push({
                ratePlanId: rp,
                roomTypeId: rt,
                otaId: ot,
              });
            });
          });
        });
        arr.filter(
          (a) =>
            a.ratePlanId !== this.master.ratePlanId &&
            a.roomTypeId !== this.master.roomTypeId &&
            a.otaId !== this.master.otaId
        );
        if (arr.length === 0) return;
        body = {
          derivationId: null,
          children: [...arr],
          master: {
            ratePlanId: this.master.ratePlanId,
            roomTypeId: this.master.roomTypeId,
            otaId: this.master.otaId,
          },
        };
      }

      if (this.fomularSelected == "0") {
        (body.rateIndex = parseFloat(this.itemAdd.rateIndex)),
          (body.rateSupplement = +this.itemAdd.rateSupplement),
          (body.rateAdditional = +this.itemAdd.rateAdditional),
          (body.restrictionType = this.restrictionType);
        body.roomRateDerivationsDenominatorList = [];
      } else {
        (body.rateIndex = parseFloat(this.itemAddWithDenominator.rateIndex)),
          (body.rateSupplement = +this.itemAddWithDenominator.rateSupplement),
          (body.rateAdditional = +this.itemAddWithDenominator.rateAdditional),
          (body.restrictionType = this.restrictionType);
        body.roomRateDerivationsDenominatorList =
          this.itemAddWithDenominator.roomRateDerivationsDenominatorList;
      }

      this.tmpBody = body;
      this.confirmSetUp(body);
    },
    confirmSetUp(body) {
      this.isConfirmLoading = true;
      this.confirmPagination.page = 0;
      masterRateService.getRoomRateListFormula(body).then((res) => {
        this.isConfirmLoading = false;
        if (res.responseCode === 0) {
          if (res.data.length == 0) {
            this.dialogMessage = this.$t("CUSTOM_NOT_MATCH");
            this.showDialog = true;
            return;
          }
          let removeList = JSON.parse(JSON.stringify(res.data.removeList));
          let listConfirm = JSON.parse(JSON.stringify(res.data.newList));
          if (listConfirm.length == 0) {
            const messages = {
              ROOM_TYPE: this.$t("ROOM_TYPE_NOT_MATCH"),
              RATE_PLAN: this.$t("SALE_PACKAGE_NOT_MATCH"),
              OTA: this.$t("SALE_CHANNEL_NOT_MATCH"),
              CUSTOM: this.$t("CUSTOM_NOT_MATCH"),
            };
            this.dialogMessage = messages[this.configBy] || this.$t("CUSTOM_NOT_MATCH");
            this.showDialog = true;
          } else {
            this.isSetup = false;
            this.isConfirm = true;
            this.isProcess = true;
            listConfirm.forEach(item => {
              item.MASTER_PRODUCT = item.master.roomTypeI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.master.ratePlanI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.master.otaI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name;
              item.DERIVED_PRODUCT = item.roomTypeI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.ratePlanI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.otaI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name;
              item.fomulaType = this.fomulaType.addNew;
              item.background = 'new-fomula';
              if ((item.restrictionType & this.bitSetupPrice) != 0) {
                item.PRICE_FORMULA = this.generateHtmlString(item);
              }

              item.restrictionTypeOld = 0;
              item.PRICE_FORMULA_OLD = `<span></span>`;

              const filter = removeList.find(del => 
                del.master.roomTypeId === item.master.roomTypeId &&
                del.master.ratePlanId === item.master.ratePlanId &&
                del.master.otaId === item.master.otaId &&
                del.roomTypeId === item.roomTypeId &&
                del.ratePlanId === item.ratePlanId &&
                del.otaId === item.otaId
              );
              if (filter) {
                if (
                  filter.rateIndex == item.rateIndex &&
                  filter.rateSupplement == item.rateSupplement &&
                  filter.rateAdditional == item.rateAdditional &&
                  filter.restrictionType == item.restrictionType &&
                  JSON.stringify(filter.roomRateDerivationsDenominatorList) == JSON.stringify(item.roomRateDerivationsDenominatorList)
                ) {
                  item.fomulaType = this.fomulaType.noChange;
                  item.background = 'old-fomula';
                } else {
                  item.fomulaType = this.fomulaType.willChange;
                  item.background = 'change-fomula';
                }

                item.restrictionTypeOld = filter.restrictionType;
                if ((filter.restrictionType & this.bitSetupPrice) != 0) {
                  item.PRICE_FORMULA_OLD = this.generateHtmlString(filter);
                }
              }
            });

            const filteredRemoveList = removeList.filter(item => 
              !listConfirm.some(confirm => 
                confirm.master.roomTypeId === item.master.roomTypeId &&
                confirm.master.ratePlanId === item.master.ratePlanId &&
                confirm.master.otaId === item.master.otaId &&
                confirm.roomTypeId === item.roomTypeId &&
                confirm.ratePlanId === item.ratePlanId &&
                confirm.otaId === item.otaId
              )
            ).reduce((uniqueList, currentItem) => {
              const isDuplicate = uniqueList.some(existingItem => 
                existingItem.master.roomTypeId === currentItem.master.roomTypeId &&
                existingItem.master.ratePlanId === currentItem.master.ratePlanId &&
                existingItem.master.otaId === currentItem.master.otaId &&
                existingItem.roomTypeId === currentItem.roomTypeId &&
                existingItem.ratePlanId === currentItem.ratePlanId &&
                existingItem.otaId === currentItem.otaId
              );
              if (!isDuplicate) uniqueList.push(currentItem);
              return uniqueList;
            }, []);

            filteredRemoveList.forEach(item => {
              item.fomulaType = this.fomulaType.willDelete;
              item.background = 'del-fomula';
              item.restrictionTypeOld = item.restrictionType;
              item.MASTER_PRODUCT = item.master.roomTypeI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.master.ratePlanI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.master.otaI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name;
              item.DERIVED_PRODUCT = item.roomTypeI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.ratePlanI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name
                      + '-' +
                        item.otaI18n.find(
                          (x) => x.lang == this.defaultI18n
                        ).name;
              item.PRICE_FORMULA = `<span></span>`;
              if ((item.restrictionType & this.bitSetupPrice) != 0) {
                item.PRICE_FORMULA_OLD = this.generateHtmlString(item);
              }
              item.restrictionType = 0;
            });
            
            listConfirm.push(...filteredRemoveList);
            listConfirm.sort((a, b) => a.fomulaType - b.fomulaType);
            this.listConfirmTmp = listConfirm;
            if (this.listConfirmTmp.length > 0) {
              this.confirmPagination.totalPage = Math.ceil(this.listConfirmTmp.length / this.confirmPagination.perPage);
              this.listConfirm = this.listConfirmTmp.slice(
                this.confirmPagination.page * this.confirmPagination.perPage, 
                (this.confirmPagination.page + 1) * this.confirmPagination.perPage
              );
              this.confirmPagination.page += 1;
            }
            this.isProcess = false;
          }
        } else {
          _alert(res, this.$t(res.data), false);
        }
      }).catch(() => {
        this.isConfirmLoading = false;
        let res = {
          responseCode: 1,
          data: 'ERROR'
        };
        _alert(res, this.$t(res.data), false);
      });
    },
    saveFomularSetUp() {
      this.onSaving = true;
      try {
        masterRateService
        .saveFormulaItem(this.tmpBody)
        .then((res) => {
          this.onSaving = false;
          _alert(res, this.$t(res.data), false);
          if (res.responseCode === 0) {
            this.isSetup = false;
            this.isConfirm = false;
            this.itemAdd = {
              idMaster: null,
              idChild: null,
              rateIndex: 1,
              rateSupplement: 0,
              rateAdditional: 0,
            };
            this.restrictionType = 0;
            this.tmpBody = null;
            this.getRoomRateWithFormula();
            this.changeMaster(null);
          }
        });
      } catch (error) {
        this.isSetup = false;
        this.isConfirm = false;
        this.message = this.$t('WAITING_UPDATE');
        setTimeout(() => {
          this.message = null;
        }, 5000)
      }
      
    },
    addFormula() {
      if (!this.$refs.formNew.validate()) return false;
      if (!this.itemAdd.idChild || !this.itemAdd.idMaster) return;
      const child = this.allRoomRate.find((e) => e.id === this.itemAdd.idChild);
      const master = this.allRoomRate.find(
        (e) => e.id === this.itemAdd.idMaster
      );
      const body = {
        derivationId: null,
        children: {
          ratePlanId: child.ratePlanId,
          roomTypeId: child.roomTypeId,
          id: child.id,
        },
        master: {
          ratePlanId: master.ratePlanId,
          roomTypeId: master.roomTypeId,
          id: master.id,
        },
        rateIndex: parseFloat(this.itemAdd.rateIndex),
        rateSupplement: +this.itemAdd.rateSupplement,
        rateAdditional: +this.itemAdd.rateAdditional,
      };
      masterRateService
        .saveFormulaItem(body)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
          if (res.responseCode === 0) {
            this.itemAdd = {
              idMaster: null,
              idChild: null,
              rateIndex: 1,
              rateSupplement: 0,
              rateAdditional: 0,
            };
            this.getRoomRateWithFormula();
            this.changeMaster(null);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    removeFormula(data) {
      if (this.isDeleting == true) {
        return;
      }
      this.isDeleting = true;
      masterRateService
        .removeFormula(data.derivationId)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
          this.getRoomRateWithFormula();
          this.changeMaster(null);
        })
        .finally(() => {
          this.isLoading = false;
          this.isDeleting = false;
        });
    },
    getAllRoomRate() {
      masterRateService
        .getAllRoomRateMasterRate()
        .then((res) => {
          if (res.responseCode === 0) {
            this.allRoomRate = res.data;
            const rt = this.allRoomRate.map(e => Object.assign({}, {
              value: e.roomTypeId,
              text: e.roomTypeI18n.find(n => n.lang === this.defaultI18n).name
            }));
            this.roomTypes = rt.filter((value, index, self) => 
              index === self.findIndex((t) => (
                t.value === value.value
              ))
            );
            this.roomTypes = rt.filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.value === value.value)
            );
             
            const pl = this.allRoomRate.reduce((uniquePlans, e) => {
              const ratePlan = {
                value: e.ratePlanId,
                text: e.ratePlanI18n.find(n => n.lang === this.defaultI18n).name || '',
                planSortIndex: e.planSortIndex,
                planCreatedDate: new Date(e.planCreatedDate)
              };
              if (!uniquePlans.some(plan => plan.value === ratePlan.value)) {
                uniquePlans.push(ratePlan);
              }
              return uniquePlans;
            }, []).sort((a, b) => {
              if (b.planSortIndex !== a.planSortIndex) {
                return b.planSortIndex - a.planSortIndex;
              }
              if (b.planCreatedDate.getTime() !== a.planCreatedDate.getTime()) {
                return b.planCreatedDate.getTime() - a.planCreatedDate.getTime();
              }
              return a.text.localeCompare(b.text);
            });
            this.ratePlans = pl.map(e => Object.assign({}, {
              value: e.value,
              text: e.text
            }));

            const os = this.allRoomRate.map(e => Object.assign({}, {
              value: e.otaId,
              text: e.otaI18n.find(n => n.lang === this.defaultI18n).name
            }));
            this.otas = os.filter((value, index, self) => 
              index === self.findIndex((t) => (
                t.value === value.value
              ))
            );
            this.otas.sort((a, b) => a.text.localeCompare(b.text));
          }
        })
        .finally(() => (this.isLoading = false));
    },
    changeMaster(idMaster) {
      if (!idMaster) {
        this.roomRateChild = [];
        return;
      }

      this.itemAdd.idChild = null;
      const arrChild = this.dataRoomRateFormula.map((e) => e.id);
      const arrMaster = Array.from(
        new Set(this.dataRoomRateFormula.map((e) => e.master.id))
      );
      this.roomRateChild = this.allRoomRate
        .filter(
          (e) =>
            !arrChild.includes(e.id) &&
            e.id !== idMaster &&
            !arrMaster.includes(e.id)
        )
        .map((ob) =>
          Object.assign(
            {},
            {
              id: ob.id,
              label:
                ob.roomTypeI18n.find((y) => y.lang == this.defaultI18n).name +
                " - " +
                ob.ratePlanI18n.find((y) => y.lang == this.defaultI18n).name,
            }
          )
        );
    },
    calculateFormulaByDate(derivationId) {
      localStorage.setItem("derivationId", derivationId);
      this.$router.push({ name: "calculateByDate" });
    },
    _moment: moment,
    generateHtmlString(item) {
      const hasDenominatorList =
        item.roomRateDerivationsDenominatorList &&
        item.roomRateDerivationsDenominatorList.length > 0;

      const denominatorHtml = hasDenominatorList
        ? item.roomRateDerivationsDenominatorList
            .map(
              (denominator, index) =>
                `<div>
                  (1 &#8722; ${denominator} &#37;)
                  ${
                    index < item.roomRateDerivationsDenominatorList.length - 1
                      ? '<span class="px-1">&#215;</span>'
                      : ''
                  }
                </div>`
            )
            .join('')
        : '';

      return `
        <div class="txt-nowrap d-flex align-center">
          <span class="font-weight-bold">C = </span>
          <div
            class="ml-2"
            style="display: inline-flex;flex-direction: column;align-items: center;"
          >
            <div style="display: inline-block">
              (<span class="font-weight-bold">M</span>
              &#177; ${this.formatCurrency(item.rateAdditional)}) &#215;${item.rateIndex}
              &#177; ${this.formatCurrency(item.rateSupplement)}
            </div>
            <div
              class="w-100 d-flex"
              style="${hasDenominatorList ? 'border-top: 1px solid #6c757d' : 'display: none;'}"
            >
              ${denominatorHtml}
            </div>
          </div>
        </div>
      `;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="scss" scoped>
.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(34, 33, 33, 0.5); /* Nền mờ */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.alert-card {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  padding: 16px;
}
.text-truncate-min {
  max-width:100px !important; 
  white-space: nowrap; 
  text-overflow: ellipsis; 
  overflow:hidden;
}
</style>
